<template>
  <div>
    <v-app-bar flat height="150" color="white">
      <v-row
        align="center"
        :class="[$vuetify.breakpoint.mdAndUp ? 'pdx-10' : 'mx-1']"
      >
        <!-- <router-link to="/shop/reseller/fourello">
          <v-img
            contain
            src="@/assets/images/reseller/logo.png"
            max-height="250"
            max-width="250"
          ></v-img>
        </router-link> -->
        
        <div
          class="display-3 blue-grey--text font-weight-black text--lighten-1"
          @click="$router.push(`/shop/reseller/${$route.params.slug}`)"
        >
          <img
            :src="resellerLogo"
            width="175px"
            style="object-fit: contain"
          />
        </div>

        <v-spacer></v-spacer>

        <v-row justify="end" class="hidden-md-and-up">
          <slot name="nav-drawer"></slot>
        </v-row>

        <v-row justify="end" class="hidden-sm-and-down">
          <v-hover v-slot="{ hover }">
            <a :href="`mailto:${reseller.email}`">
              <v-img
                v-if="hover"
                contain
                src="@/assets/images/reseller/envelope_accent.png"
                max-height="50"
                max-width="50"
                class="mr-8 text-hover"
              ></v-img>
              <v-img
                v-else
                contain
                src="@/assets/images/reseller/envelope.png"
                max-height="50"
                max-width="50"
                class="mr-8 text-hover"
              ></v-img>
            </a>
          </v-hover>

          <v-hover v-slot="{ hover }">
            <v-img
              v-if="hover || question_dialog"
              contain
              src="@/assets/images/reseller/question_accent.png"
              max-height="50"
              max-width="50"
              class="text-hover"
              @click="question_dialog = true"
            ></v-img>
            <v-img
              v-else
              contain
              src="@/assets/images/reseller/question.png"
              max-height="50"
              max-width="50"
              class="text-hover"
              @click="question_dialog = true"
            ></v-img>
          </v-hover>
        </v-row>
      </v-row>
    </v-app-bar>

    <QuestionDialog v-model="question_dialog" :logo="resellerLogo" :items="faqs"></QuestionDialog>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";

const ResellersApi = Repository.get("resellers");
export default {
  name: "ResellerHeader",

  components: {
    QuestionDialog: () => import("./QuestionDialog.vue"),
  },

  data: () => ({
    question_dialog: false,
    reseller: {},
    resellerId: null
  }),

  props: {
    // reseller: {
    //   type: Object,
    //   required: true,
    // },
    faqs: {
      type: Array,
      default: () => {
        return [];
      }
    },
  },

  computed: {
    resellerLogo() {
      let reseller = this.reseller;

      if (reseller) {
        if(reseller.logo_image) {
          return reseller.logo_image.main || null;
        }
      }

      return null;
    }
  },
  methods: {
    async getReseller() {
        let slug = this.$route.params.slug;

        await ResellersApi
          .getDetailsViaSlug(slug)
          .then(response => {
            let {
              data: {
                data : item
              }
            } = response;

            this.resellerId = item.id;
            this.reseller = item;

            RESELLER_EVENT_BUS.reseller = item;
          })
          .catch(error => {
            console.log({ error });
          })
    }
  },
  mounted() {
    this.getReseller()
  }
};
</script>

<style lang="scss" scoped>
</style>